import script from "./OrderPaymentFail.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderPaymentFail.vue?vue&type=script&setup=true&lang=js"

import "./OrderPaymentFail.vue?vue&type=style&index=0&id=2442ed3a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2442ed3a"]])

export default __exports__